import { render, staticRenderFns } from "./HistoryCPPT.vue?vue&type=template&id=a0f40a4c&scoped=true"
import script from "./HistoryCPPT.vue?vue&type=script&lang=js"
export * from "./HistoryCPPT.vue?vue&type=script&lang=js"
import style0 from "./HistoryCPPT.vue?vue&type=style&index=0&id=a0f40a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f40a4c",
  null
  
)

export default component.exports